import React from "react";

const Footer = () => {
  return (
    <footer className="bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 py-8 px-4 w-full relative overflow-hidden">
      {/* 배경 패턴 */}
      <div className="absolute inset-0 bg-gradient-to-r from-blue-900/5 to-rose-900/5"></div>
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_30%_40%,rgba(120,119,198,0.05),transparent_70%)]"></div>
      
      <div className="max-w-6xl mx-auto relative z-10">
        {/* 회사명 섹션 */}
        <div className="mb-8 text-center">
          <h3 className="text-2xl md:text-3xl font-bold text-white mb-2">
            <span className="bg-gradient-to-r from-blue-400 to-rose-400 bg-clip-text text-transparent">
              SOLCOMBINE
            </span>
          </h3>
          <p className="text-slate-400 text-sm md:text-base">
            혁신적인 솔루션으로 함께하는 디지털 파트너
          </p>
        </div>

        {/* 회사 정보 섹션 */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-8">
          {/* 대표 정보 */}
          <div className="bg-slate-800/50 backdrop-blur-sm rounded-lg p-4 border border-slate-700/50">
            <h4 className="text-blue-400 font-semibold mb-3 text-sm uppercase tracking-wide">
              대표 정보
            </h4>
            <div className="space-y-2 text-sm">
              <div className="flex items-center gap-2">
                <span className="text-slate-400">👥</span>
                <span className="text-slate-300">심재문 최진형</span>
              </div>
            </div>
          </div>

          {/* 연락처 정보 */}
          <div className="bg-slate-800/50 backdrop-blur-sm rounded-lg p-4 border border-slate-700/50">
            <h4 className="text-rose-400 font-semibold mb-3 text-sm uppercase tracking-wide">
              연락처
            </h4>
            <div className="space-y-2 text-sm">
              <div className="flex items-center gap-2">
                <span className="text-slate-400">📞</span>
                <span className="text-slate-300">1800-8477</span>
              </div>
              <div className="flex items-center gap-2">
                <span className="text-slate-400">✉️</span>
                <span className="text-slate-300 break-all">sckcs@solcombine.com</span>
              </div>
            </div>
          </div>

          {/* 사업자 정보 */}
          <div className="bg-slate-800/50 backdrop-blur-sm rounded-lg p-4 border border-slate-700/50 md:col-span-2 lg:col-span-1">
            <h4 className="text-green-400 font-semibold mb-3 text-sm uppercase tracking-wide">
              사업자 정보
            </h4>
            <div className="space-y-2 text-sm">
              <div className="flex items-start gap-2">
                <span className="text-slate-400 mt-0.5">🏢</span>
                <span className="text-slate-300">801-86-02860</span>
              </div>
              <div className="flex items-start gap-2">
                <span className="text-slate-400 mt-0.5">📋</span>
                <span className="text-slate-300">제 2023-서울강동-2648 호</span>
              </div>
            </div>
          </div>
        </div>

        {/* 주소 섹션 */}
        <div className="bg-slate-800/30 backdrop-blur-sm rounded-lg p-4 border border-slate-700/50 mb-8">
          <h4 className="text-amber-400 font-semibold mb-3 text-sm uppercase tracking-wide">
            오시는 길
          </h4>
          <div className="flex items-start gap-2 text-sm">
            <span className="text-slate-400 mt-0.5">📍</span>
            <span className="text-slate-300 leading-relaxed">
              서울시 강서구 마곡중앙5로1길 20, 보타닉비즈타워 519호
            </span>
          </div>
        </div>

        {/* 저작권 섹션 */}
        <div className="text-center pt-6 border-t border-slate-700/50">
          <p className="text-slate-400 text-xs md:text-sm">
            Copyright © 2023 <span className="text-blue-400 font-medium">SOLCOMBINE</span>. All Rights Reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
